import { forwardRef } from "react";
import type { HomepageBlock4Props } from "../../Homepage/HomepageBlock4/HomepageBlock4";
import { HomepageBlock4 } from "../../Homepage/HomepageBlock4/HomepageBlock4";

export const SalesBlock7 = forwardRef<HTMLDivElement, HomepageBlock4Props>(
  ({ ...rest }, ref) => <HomepageBlock4 ref={ref} {...rest} />,
);

SalesBlock7.displayName = "SalesBlock7";
